import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { inject, observer } from 'mobx-react'
/* eslint-enable */

import styleA from './style'
import styleB from '../../style'

import Container from '../../partials/Container'

import BillingTable from '../../partials/BillingTable'

import access from '../../../../utils/access'
import uRevenue from '../../../../utils/revenue'

const PAYMENT_TYPE = ['paypal', 'wire']

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

@inject('Auth', 'User', 'Payment', 'Community', 'Config')
@observer
export class CommunityBilling extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      active: {},
      editor: {}
    }
  }

  componentWillMount () {
    const comId = this.props.match.params.comId
    const _findReports = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _findReports()
        }

        Promise.all([
          ...(!this.props.Community.all.slice().find(c => c.id === comId)
            ? [this.props.Community.getCommunity(comId)]
            : []),
          this.props.Payment.getRevenueReport(comId),
          this.props.Payment.getTransactionReport(comId)
        ]).catch(() => this.props.history.push(`/dashboard/community`))
      }, 500)
    }

    _findReports()
  }

  onAddClick (e) {
    const date = new Date()
    this.setState({
      ...this.state,
      active: { active: true },
      editor: {
        date: date.toISOString().slice(0, 10),
        amount: 0,
        type: 0
      }
    })
  }

  onItemClick (e) {
    const comId = this.props.match.params.comId
    const _type = e.currentTarget.dataset.type
    const _id = e.currentTarget.dataset.tid

    const _transaction = (this.props.Payment[_type][comId] || [])
      .slice()
      .find(item => item.id + '' === _id)

    const _editor = {
      date: _transaction.date,
      amount: _transaction.total || _transaction.amount,
      type: PAYMENT_TYPE.findIndex(t => t === _transaction.type)
    }

    this.setState({
      active: {
        active: true,
        ...(this.state.active.id === _id && this.state.active.type === _type
          ? {}
          : { type: _type, id: _id })
      },
      editor: {
        ..._editor,
        type: _editor.type > 0 ? _editor.type : 0
      }
    })
  }

  onTransactionFormSubmit (e) {
    e.preventDefault()

    const comId = this.props.match.params.comId

    if (this.state.active.type && this.state.active.id) {
      Promise.all(
        Object.keys(this.state.editor).map(key =>
          this.props.Payment.patchTransaction(
            comId,
            this.state.active.id,
            key,
            key === 'type'
              ? PAYMENT_TYPE[this.state.editor.type]
              : this.state.editor[key]
          )
        )
      ).then(() =>
        this.setState({
          ...this.state,
          editor: {},
          active: {}
        })
      )
    } else {
      this.props.Payment.postTransaction(comId, {
        ...this.state.editor,
        payee: (
          this.props.Community.all.slice().find(c => c.id === comId) || {}
        ).paypal,
        type: PAYMENT_TYPE[this.state.editor.type]
      }).then(() =>
        this.setState({
          ...this.state,
          editor: {},
          active: {}
        })
      )
    }
  }

  onInputChange (e) {
    this.setState({
      ...this.state,
      editor: {
        ...this.state.editor,
        [e.target.name]: e.target.value
      }
    })
  }

  renderTransactionForm () {
    const comId = this.props.match.params.comId

    if (!access.adminCom(this.props.User.me.permissions || {})) {
      return null
    }

    if (!this.state.active.active) {
      return <NavigationArea onAddClick={this.onAddClick.bind(this)} />
    }

    const _transaction = this.state.active.type
      ? (this.props.Payment[this.state.active.type][comId] || [])
          .slice()
          .find(item => item.id + '' === this.state.active.id)
      : null

    return (
      <TransactionForm
        theme={THEME_LIST[this.props.Config.theme]}
        {..._transaction || {}}
        editor={this.state.editor}
        onSubmit={this.onTransactionFormSubmit.bind(this)}
        onInputChange={this.onInputChange.bind(this)}
        dType={this.state.active.type}
      />
    )
  }

  render () {
    const comId = this.props.match.params.comId
    const revenue = (this.props.Payment.revenue[comId] || []).reduce(
      uRevenue.reduceSumRevenue,
      []
    )
    const transactions = (this.props.Payment.transactions[comId] || []).slice()

    return (
      <Container {...this.props}>
        <Row>
          <Col xs='12' lg='5'>
            <h2 className={css(styleB.headers.h2)}>Billing</h2>
          </Col>
          <Col>{this.renderTransactionForm()}</Col>
        </Row>
        <Row>
          <BillingTable
            theme={THEME_LIST[this.props.Config.theme]}
            onItemClick={this.onItemClick.bind(this)}
            active={this.state.active}
            revenue={revenue}
            transactions={transactions}
          />
        </Row>
      </Container>
    )
  }
}

const NavigationArea = props => {
  return (
    <Row>
      <Col />
      <Col>
        <span
          className={css(styleB.buttons.button, styleB.buttons.red)}
          onClick={props.onAddClick}
        >
          Add new
        </span>
      </Col>
    </Row>
  )
}

const TransactionForm = props => {
  return (
    <form
      onSubmit={props.onSubmit}
      className={`row ${css(
        styleA.form.container,
        styleA[props.theme.name]
          ? styleA[props.theme.name].form.container
          : null
      )}`}
    >
      <Col
        className={css(
          styleA.form.inputWrapper,
          styleA[props.theme.name]
            ? styleA[props.theme.name].form.inputWrapper
            : null
        )}
      >
        <input
          type={`text`}
          name={`date`}
          placeholder={`date`}
          value={props.editor.date}
          {...(props.dType === 'transactions' ? { disabled: true } : {})}
          onChange={props.onInputChange}
          className={css(
            styleA.form.input,
            styleA[props.theme.name]
              ? styleA[props.theme.name].form.input
              : null
          )}
        />
      </Col>
      <Col
        className={css(
          styleA.form.inputWrapper,
          styleA[props.theme.name]
            ? styleA[props.theme.name].form.inputWrapper
            : null
        )}
      >
        <input
          type={`text`}
          name={`amount`}
          placeholder={`amount`}
          value={props.editor.amount}
          onChange={props.onInputChange}
          className={css(
            styleA.form.input,
            styleA[props.theme.name]
              ? styleA[props.theme.name].form.input
              : null
          )}
        />
      </Col>
      <Col
        className={css(
          styleA.form.inputWrapper,
          styleA[props.theme.name]
            ? styleA[props.theme.name].form.inputWrapper
            : null
        )}
      >
        <select
          name={`type`}
          value={props.editor.type}
          onChange={props.onInputChange}
          className={css(
            styleA.form.select,
            styleA[props.theme.name]
              ? styleA[props.theme.name].form.select
              : null
          )}
        >
          <option value={0}>paypal</option>
          <option value={1}>wire</option>
        </select>
      </Col>
      <Col
        xs='3'
        className={css(
          styleA.form.inputWrapper,
          styleA[props.theme.name]
            ? styleA[props.theme.name].form.inputWrapper
            : null
        )}
      >
        <button
          className={css(
            styleB.buttons.button,
            styleB.buttons.red,
            styleA.form.button
          )}
        >
          Save
        </button>
      </Col>
    </form>
  )
}

export default CommunityBilling



// WEBPACK FOOTER //
// ./src/components/Community/Billing/Main/index.js